import type { ToolId } from "../../features/toolExperience/types";
export interface WorkFeedItem {
  key: string;
  toolId: ToolId;
  projectId?: string;
  title: string;
  href: string;
  timestamp: string | null;
  timestampKind: "updated" | "created" | "checked" | "completed";
  stateLabel: string;
  attentionReason?: "failed" | "unacknowledged-change" | "approval-required";
}
export function sortWorkFeed<
  T extends { key: string; timestamp: string | null },
>(items: T[]): T[] {
  return [...items].sort(
    (a, b) =>
      (Date.parse(b.timestamp || "") || 0) -
        (Date.parse(a.timestamp || "") || 0) || a.key.localeCompare(b.key),
  );
}
export function validTimestamp(value?: string | null): string | null {
  return value && Number.isFinite(Date.parse(value)) ? value : null;
}
